import React from 'react';
import styled from 'styled-components';

import { WithLegacy } from '~/_legacy/components/WithLegacy';

import { OnlyWeb } from '~/components/_for-next/OnlyWeb';
import { WithNextSeo } from '~/components/_for-next/WithNextSeo';
import Layout from '~/pages/_layout.page';
import { Futura } from '~/styles';
import { media } from '~/utils';

export default function Page() {
  return (
    <WithNextSeo title='プライバシーポリシー'>
      <OnlyWeb>
        <WithLegacy>
          <Privacy />
        </WithLegacy>
      </OnlyWeb>
    </WithNextSeo>
  );
}

function Privacy() {
  return (
    <Layout pageTitle='プライバシーポリシー'>
      <Wrapper>
        <Main>
          <Title>プライバシーポリシー</Title>
          <Image src='/images/privacy1.png' alt='privacy1' />

          <Section>個人情報の適切な取得、利用および提供</Section>

          <Text>
            事業遂行のために必要な範囲内で利用目的を明確に定め、個人情報（個人情報の保護に関する法律（平成15年5月30日号外法律第57号、その後の改正を含みます。以下「個人情報保護法」といいます。）第2条第1項に規定する個人情報をいいます。以下同じ。）の取得、利用および提供を適切に行います。
            <br />
            取得した個人情報は利用目的の範囲内でのみ利用し、目的外利用を行わないための措置を講じます。
            <br />
            なお、個人情報の取扱いの全部または一部を第三者に委託する場合には、十分な保護水準を満たした者を選定し、契約等により必要かつ適切な措置を講じます。
          </Text>

          <Section>個人情報の取扱いに関する法令、国が定める指針その他の規範の遵守</Section>

          <Text>
            取り扱う個人情報について、個人情報の取扱いに関する法令、国が定める指針およびその他の規範を遵守します。
          </Text>

          <Section>個人情報の漏えい、滅失またはき損の防止および是正</Section>

          <Text>
            個人情報への不正アクセス、個人情報の紛失、破壊、改ざん、漏洩等のリスクに対して合理的な安全対策および是正措置を講じます。
          </Text>

          <Section>苦情および相談への対応</Section>

          <Text>
            本人からの当該個人情報の開示、訂正、削除、利用停止等の要請および苦情や相談に対して遅滞無く対応いたします。
          </Text>

          <Section>個人情報保護マネジメントシステムの継続的改善</Section>

          <Text>個人情報保護マネジメントシステムを継続的に見直し改善いたします。</Text>

          <Text>
            制定日 2020年８月31日
            <br />
            <Futura>ICHI COMMONS</Futura>株式会社
            <br />
            代表取締役　伏見　崇宏
          </Text>

          <Margin />

          <Title>個人情報の取り扱いについて</Title>

          <Image src='/images/privacy2.png' alt='privacy2' />

          <Section>個人情報の利用目的</Section>

          <Text>
            当社がご利用者様その他関係者様からお預かりする個人情報は、以下の目的のために利用いたします。
            <br />
            なお、個人情報の収集に際し、利用目的を別途ご本人に明示する場合には、それらの個人情報は収集の際に明示された目的のために利用いたします。
          </Text>

          <Text>各サービスのご利用者様の情報</Text>

          <Text>
            ・ご利用登録に関する各種手続き
            <br />
            ・お申込みいただくサービスのご提供
            <br />
            ※ご利用いただくサービスによっては、第三者へ提供することがございます。詳細は「２．個人情報の第三者への提供」をご覧ください。
            <br />
            ・お申込みいただいたサービスに関連する情報のご案内
            <br />
            ・サービスの開発、改善のための分析
            <br />
            ・当社の事業活動に関する調査等へのご協力依頼
          </Text>

          <Text>各サービスのご利用者様のうち法人であるものの役職員の情報</Text>

          <Text>
            ・サービスおよび関連する情報のご案内・ご提供、ご要望の聴取
            <br />
            ・各種セミナーのお申込み受付
            <br />
            ・ご利用者様の管理
          </Text>

          <Text>その他の関係者様の情報</Text>

          <Text>
            当社が業務の委託を受けることに伴って取得した情報
            <br />
          </Text>

          <Text>・委託された業務の遂行</Text>

          <Text>広報活動における取材によって取得した情報</Text>

          <Text>
            ・当社および提携先各社の広報媒体・各種メディアへの掲載
            <br />
            ・広報活動に関するご連絡
          </Text>

          <Text>各サービスの参加者の情報</Text>

          <Text>
            ・サービスの参加に関する各種手続き
            <br />
            ・サービスに関するご連絡、ピッチコンペティション等のプログラムの実施
            <br />
            ・当社のサービス、プログラムの開発・改善のための分析
            <br />
            ・当社の事業活動に関する調査等のご協力依頼
            <br />
            ・当社および提携先各社の広報媒体・各種メディアへの掲載
            <br />
            ・当社および提携先各社のサービス、プログラム、イベント等のご案内
          </Text>

          <Section>個人情報の第三者への提供</Section>

          <Text>
            当社、次のいずれかに該当する場合を除き、お預かりした個人情報を第三者に提供いたしません。
            <br />
            ご本人様の同意を得た場合
            <br />
            利用目的の達成に必要な範囲内において外部委託する場合
            <br />
            法令に基づき提供を求められた場合
            <br />
            人の生命、身体または財産の保護のために必要な場合であって、ご本人様の同意を得ることが困難である場合
            <br />
            公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難である場合
            <br />
            国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
          </Text>

          <Section>個人情報に関するご要望とお問い合わせの受付</Section>

          <Text>
            本サービスでの情報の取り扱いに関するご質問・苦情・ご相談などがある場合、以下のメールアドレス宛にご連絡ください。
            <br />
            Contact(at-mark)ichicommons.com
            <br />
            *(at-mark)は＠と置き換えてください。
          </Text>
        </Main>
      </Wrapper>
    </Layout>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Main = styled.div`
  width: 810px;
  margin-top: 100px;
  margin-bottom: 100px;

  ${media.sp`
    width: calc(100% - 40px);
    margin: 100px 20px;
  `}
`;

const Title = styled.h3`
  color: #2f2f2f;
  font-size: 26px;
  font-weight: bold;
`;

const Image = styled.img`
  width: 810px;
  height: 400px;
  margin-top: 40px;
  margin-bottom: 20px;

  ${media.sp`
    width: 100%;
    height: auto;
  `}
`;

const Section = styled.h4`
  color: #2f2f2f;
  font-size: 22px;
  font-weight: bold;
  margin-top: 20px;
`;

const Text = styled.div`
  color: #313131;
  font-size: 16px;
  line-height: 32px;
  margin-top: 20px;
`;

const Margin = styled.div`
  margin-top: 120px;
  width: 100%;
`;
